export interface Translation {
  key: string;
  args?: TranslationArgs;
}

export type TranslationArgs = Record<string, unknown>;
